import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api.service';
import { UserService } from '../_service/user.service';
import { Router } from '@angular/router';
import { AlertifyService } from '../_service/alertify.service';
import { User } from '../_models/user';
import { MatDialog } from '@angular/material';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  NgModel
} from '@angular/forms';
import { TreeComponent } from '../tree/tree.component';
import { AuthService } from '../_service/auth.service';

@Component({
  selector: "invite",
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css']
})
export class InviteComponent implements OnInit {
  inviteUserForm: FormGroup;

  constructor(
    private http: HttpClient,
    private api: ApiService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private alertify: AlertifyService,
    public dialog: MatDialog,
    public fb: FormBuilder
  ) {
    this.inviteUserForm = fb.group({
      firstNameFormControl: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        this.WhitespaceValidator
      ]),
      lastnameFormControl: new FormControl('', [
        Validators.required,
        Validators.maxLength(70),
        this.WhitespaceValidator
      ]),
      emailFormControl: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
      ]),
      authorityFormControl: new FormControl('', []).clearValidators()
    });
  }

  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  user: User;

  model: any = {
    authorityUnitId: null,
    firstName: '',
    lastName: '',
    email: ''
    //  userId: null
  };

  authorities;
  level1Authorities;
  level2Authorities;
  level3Authorities;
  locations;
  selectedHospital: string;
  userExists: any = [];
  invitationSuccessful: any = [];
  locationNotAssigned: any = {};
  invalidDomainName: any = {};
  loading: any = {};
  inviteLoading = false;
  isModified = false;

  sdsUserId: any;
  sdsUserIdNumber: number;

  public selectedAuthority: any;
  selectedLocations: any = ([] = []);

  listOfAuthorityNames = [];

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  inviteLocationIdValidator(locationTreeId) {
    // console.log('SUCCESS => ' + locationTreeId.checklistSelection._selection);
    if (locationTreeId !== undefined) {
      for (const locationId of locationTreeId.checklistSelection._selection) {
        if (locationId.authorityUnitId !== undefined) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  ngOnInit() {
    // get userid for location tree (for site admins)
    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;
  }

  inviteFormStyle(loading) {
    if (loading) {
      return 'absolute';
    } else {
      return 'inherit';
    }

  }


  inviteUser() {
    this.inviteLoading = true;
    // const params = new URLSearchParams();

    this.model.firstName = this.inviteUserForm.get('firstNameFormControl').value.trim();
    this.model.lastName = this.inviteUserForm.get('lastnameFormControl').value.trim();
    this.model.email = this.inviteUserForm.get('emailFormControl').value.trim();

    if (this.authService.decodedToken.role === 'Site Admin') {
      this.model.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        if (loc.userId === this.sdsUserIdNumber) {
          this.model.LocationId.push(loc.authorityUnitId);
        }
      }
    }
    if (this.authService.decodedToken.role === 'Super Admin') {
      this.model.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        this.model.LocationId.push(loc.authorityUnitId);
      }
    }
    if (this.locationTree.checklistSelection.selected.length !== 0 && this.model.firstName !== '' && this.model.lastName !== ''
    && this.model.email !== '') {
      return this.userService.inviteUserBySiteAdmin(this.model).subscribe(
        res => {
          this.locationNotAssigned = res.headers.get('locationnotassigned');
          if (this.locationNotAssigned) {
            this.alertify.message(this.locationNotAssigned);
            this.inviteLoading = false;
          }
          this.invalidDomainName = res.headers.get('emailNotApproved');
          if (this.invalidDomainName) {
            this.alertify.error(this.invalidDomainName);
            this.inviteLoading = false;
          }
          this.userExists = res.headers.get('duplicateuser');
          if (this.userExists) {
            this.alertify.message(this.userExists);
            this.inviteLoading = false;
          }
          this.invitationSuccessful = res.headers.get('successfulinvitation');
          if (this.invitationSuccessful) {
            this.alertify.success(this.invitationSuccessful);
            this.isModified = true;
            this.inviteLoading = false;
            this.dialog.closeAll();
          }
        },
        error => {
          this.alertify.error('Something went wrong!');
          this.inviteLoading = false;
        }
      );
    } else if (this.model.firstName !== '' && this.model.lastName !== '' && this.model.email !== '' 
    && this.selectedLocations.length === 0) {
      this.alertify.message('Please assign a location for this user');
      this.inviteLoading = false;
    }
    this.inviteLoading = false;
  }

  assignLocation() {
    this.model.userId = this.user.userId;
    this.model.authorityUnitId = this.selectedAuthority;
    return this.userService.assignUserLocation(this.model).subscribe(res => {
      this.locations = res;
    });
  }
}

export interface Authority {
  value: string;
  viewValue: string;
}
